import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
    Col, Row, Form, FormGroup, Label, Button, Input, Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { RegisterRequest } from '../../../redux/Action/Auth/SignupAction'
import { visit } from '../../../redux/Action/Auth/LoginAction'
import Teacher from '../../../assets/Images/TeacherLogo.png'
import Assistant from '../../../assets/Images/AssistantLogo.png'
import Student from '../../../assets/Images/StudentLogo.png'
import Parent from '../../../assets/Images/ParentLogo.png'
import RenderField from '../../../components/Fields/fields'
import String from '../../../assets/Locales/teacher_locales.js';
import axios from "axios";
import { API_ENDPOINT } from '../../../AppConfig';
import { Inputs } from './inputSettings'
import { ParentInputs } from './parentInput'
import validate from './validation';
import LoadingBar from 'react-redux-loading-bar'
import { Redirect } from 'react-router-dom';
import './SignUp.css'
import { VisitorInput } from './inputSettings'

class SignUp extends Component {

    constructor(props) {
        super(props);
        this.state = {
            inputs: Inputs,
            userType: null,
            subLevels: [],
            sublevel: null,
            userTypeErr: false,
            sublevelErr: false,
            Levels: [],
            level: null,
            levelErr: false,
            countries: [],
            country: null,
            countryErr: false,
            cities: [],
            city: null,
            cityErr: false,
            areas: [],
            area: null,
            areaErr: false,
            modal: false,
            RedirectTo: false
        };
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    componentWillMount() {
        this.GetLevel()
        this.GetCountries()
        // this.GetArea()
    }

    GetLevel() {
        let url = `${API_ENDPOINT}/levels`
        axios.get(url, {
            headers: {
                "Accept-Language": localStorage.getItem('Language')
            }
        })
            .then(response => {
                // console.log("GETSUB res", response.data.data)
                this.setState({ Levels: response.data.data })
            }).catch(error => {
                // console.log("GETSUB error:", error.response);
            })
    }

    GetSubLevel(Id) {
        let url = `${API_ENDPOINT}/sublevels?level=${Id}`
        axios.get(url, {
            headers: {
                "Accept-Language": localStorage.getItem('Language')
            }
        })
            .then(response => {
                // console.log("GETSUB res", response.data.data)
                this.setState({ subLevels: response.data.data })
            }).catch(error => {
                // console.log("GETSUB error:", error.response);
            })
    }

    GetCountries() {
        let url = `${API_ENDPOINT}/country`
        axios.get(url, {
            headers: {
                "Accept-Language": localStorage.getItem('Language')
            }
        })
            .then(response => {
                console.log("GETSUB res", response.data.data)
                this.setState({ countries: response.data.data })
            }).catch(error => {
                // console.log("GETSUB error:", error.response);
            })
    }

    GetCities(Id) {
        let url = `${API_ENDPOINT}/city?countryId=${Id}`
        axios.get(url, {
            headers: {
                "Accept-Language": localStorage.getItem('Language')
            }
        })
            .then(response => {
                console.log("GETSUB fffres", response.data.data)
                this.setState({ cities: response.data.data })
            }).catch(error => {
                // console.log("GETSUB error:", error.response);
            })
    }

    GetArea(Id) {
        let url = `${API_ENDPOINT}/area?cityId=${Id}`
        console.log("urldataaa",url)
        axios.get(url, {
            headers: {
                "Accept-Language": localStorage.getItem('Language')
            }
        })
            .then(response => {
                console.log("GETSUB area res", response)
                this.setState({ areas: response.data.data })
            }).catch(error => {
                console.log("GETSUB error:", error.response);
            })
    }
    viewAsVisitor() {
        if(this.state.level&&!this.state.sublevel){
            this.setState({sublevelErr:true})
            return null
        }
        if(!this.state.level){
            this.setState({levelErr:true})
            return null
        }
        this.props.visit('VISITOR', this.state.sublevel)
        this.setState({ RedirectTo: true })
    }
    onSubmit = (values) => {
        // console.log(this.state.userType, "REGISTERATION usertype", this.state.userType === 'STUDENT' && !this.state.sublevel)
        let user = new FormData();
        user.append('firstName', values.firstName);
        user.append('secondName', values.lastName);
        user.append('type', this.state.userType);
        user.append('email', values.email);
        user.append('phone', values.phone);
        user.append('password', values.password);
        user.append('username', values.UserName);
        user.append('language', localStorage.getItem("Language") ? localStorage.getItem("Language") : 'ar');
        user.append('address', values.address);
        if (values.StudentEmail) user.append('studentEmail', values.StudentEmail);
        if (this.state.userType === "STUDENT") {
            user.append('subLevel', this.state.sublevel)
        }
        if (this.state.userType === "TEACHER") {
            user.append('area', this.state.area)
        }
        if (this.state.userType) {
            if (this.state.userType === 'STUDENT' && !this.state.sublevel) {
                this.setState({ sublevelErr: true })
                console.log("sigggnnUpp if")
            } else if (this.state.userType === 'TEACHER' && !this.state.area) {
                console.log("sigggnnUpp elseif")
                if (!this.state.area) {
                    this.setState({ areaErr: true })
                } if (!this.state.city) {
                    this.setState({ cityErr: true })
                } if (!this.state.country) {
                    this.setState({ countryErr: true })
                }
            }
            else {
                console.log("sigggnnUpp else")
                this.props.RegisterRequest(user)
            }

        } else {
            // console.log("ERRORRR ")
            this.setState({ userTypeErr: true })
        }

    }
    chahnageLang(lang) {
        localStorage.setItem('Language', lang);

    }
    showTypeError() {
        if (!this.state.userType) {
            this.setState({ userTypeErr: true })
        }
    }
    render() {
        let lang = localStorage.getItem("Language");
        if (this.state.RedirectTo) {
            return (
                <Redirect to="/home" />
            )
        }
        if (this.props.sucessRegister) {
            return (
                // <Redirect to="/home" />
                <Redirect to="/verifyaccount" />
            )
        }
        if (lang) {
            String.setLanguage(localStorage.getItem("Language"));
        } else {
            lang = "ar"
            String.setLanguage("ar");
        }
        let inputs = this.state.inputs;
        if (this.state.userType === 'GUARDIAN') {
            inputs = ParentInputs
        }
        const { handleSubmit, submitting } = this.props
        return (
            <div>
                <div className="loading-bar" >
                    <LoadingBar style={{ height: '5px', zIndex: 1000, backgroundColor: "black" }} />
                </div>
                <div className="signup-content" style={{ direction: lang === 'ar' ? 'rtl' : 'ltr' }}>
                    <div className="signup-container">
                        <Row className="login-image-content">
                            <Col md="12" className="big-img">
                                <img src={Teacher} alt="Teacher" />
                            </Col>
                            <Col md="12" className="small-imgs">
                                <img src={Student} alt="Student" />
                                <img src={Parent} alt="Parent" />
                                <img src={Assistant} alt="Assistant" />
                            </Col>
                            {/* <Col md="12" className="small-imgs">
                                <Link className="visitor-link" style={{ float: lang === "ar" ? "left" : "right" }} onClick={this.toggle}>
                                    <i className="fa fa-eye mx-2"></i>
                                    {String.viewAsVisitor}
                                </Link>
                            </Col> */}
                            <Col md="12" id="login-links">
                                {/* style={{ float: lang === "ar" ? "left" : "right",marginLeft: lang === "ar" ? "2%" : "" }} */}
                                {/* style={{ float: lang === "ar" ? "left" : "right",marginLeft: lang === "ar" ? "2%" : "" }} */}
                                <Link className="visitor-link" onClick={this.toggle}>
                                    <i className="fa fa-eye mx-2"></i>
                                    {String.viewAsVisitor}
                                </Link>
                                <Link className="visitor-link mx-3" onClick={() => { this.chahnageLang(lang === "ar" ? "en" : "ar") }}>
                                    {lang === "ar" ? "English" : "Arabic"}
                                </Link>


                            </Col>
                        </Row>
                        <Row >
                            <Col md="8" lg="6" style={{ margin: 'auto', marginTop: '2%' }}>
                                <FormGroup>
                                    <Label className={lang === "en" ? "labelInput LeftAlign" : "labelInput RightAlign"}> {lang === 'ar' ? "اختر النوع" : "Choose type"} </Label>
                                    <Input type="select" style={{ backgroundColor: "#eeeeee", borderRadius: '10px' }}
                                        onChange={(e) => this.setState({ userType: e.target.value, userTypeErr: false })}>
                                        <option > {lang === 'ar' ? "النوع" : "Type"} </option>
                                        <option value="TEACHER"> {lang === 'ar' ? "مدرس" : "Teacher"}  </option>
                                        {/* <option value="ASSISTANT"> {lang === 'ar' ? "مساعد" : "Assistant"} </option> */}
                                        <option value="STUDENT"> {lang === 'ar' ? "طالب" : "Student"} </option>
                                        <option value="GUARDIAN"> {lang === 'ar' ? "ولي امر" : "Parent"} </option>
                                    </Input>
                                </FormGroup>
                                {this.state.userTypeErr &&
                                    <h6 className={lang === "en" ? "labelInput LeftAlign" : "labelInput RightAlign"}
                                        style={{ color: 'red' }}>  {lang === 'ar' ? ' يرجى اختيار النوع  ' : 'Please choose type'} </h6>
                                }
                                <Form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                    {
                                        inputs.map((row, index) => {
                                            return (
                                                <Row>
                                                    {
                                                        row.map((element, index) => {
                                                            console.log("Element input ", element)
                                                            return (
                                                                <Field
                                                                    lang={lang}
                                                                    type={element.type}
                                                                    name={element.name}
                                                                    component={RenderField}
                                                                    label={lang === "ar" ? element.label.ar : element.label.en}
                                                                    placeholder={element.placeholder}
                                                                    options={element.options}
                                                                    size={element.size}
                                                                    display={element.display}
                                                                    optionTitle={element.optionTitle ? (lang === "ar" ? element.optionTitle.ar : element.optionTitle.en) : ""}
                                                                    inputType={element.inputType}
                                                                // title={lang === "ar" ? element.title.ar : element.title.en}
                                                                />
                                                            )
                                                        })

                                                    }
                                                    {(this.state.userType && this.state.userType === 'STUDENT') &&
                                                        <Col lg="6" md="6">
                                                            <FormGroup>
                                                                <Label className={lang === "en" ? "labelInput LeftAlign" : "labelInput RightAlign"}> {lang === 'ar' ? "اختر المرحلة" : "Choose level"} </Label>
                                                                <Input type="select" style={{ backgroundColor: "#eeeeee", borderRadius: '10px' }}
                                                                    onChange={(e) => {
                                                                        this.GetSubLevel(e.target.value)
                                                                        this.setState({ level: e.target.value, levelErr: false })
                                                                    }}>
                                                                    <option> {lang === 'ar' ? " المرحلة" : "Level"} </option>
                                                                    {this.state.Levels.map((items, index) => (
                                                                        <option value={items.id}> {items.name} </option>
                                                                    ))}

                                                                </Input>
                                                            </FormGroup>
                                                            {this.state.levelErr &&
                                                                <h6 className={lang === "en" ? "labelInput LeftAlign" : "labelInput RightAlign"}
                                                                    style={{ color: 'red' }}>  {lang === 'ar' ? ' يرجى اختيار المرحلة  ' : 'Please choose level'} </h6>
                                                            }

                                                        </Col>

                                                    }
                                                    {this.state.level &&
                                                        <Col lg="6" md="6">
                                                            <FormGroup>
                                                                <Label className={lang === "en" ? "labelInput LeftAlign" : "labelInput RightAlign"}> {lang === 'ar' ? "اختر الصف" : "Choose sub level"} </Label>
                                                                <Input type="select" style={{ backgroundColor: "#eeeeee", borderRadius: '10px' }}
                                                                    onChange={(e) => this.setState({ sublevel: e.target.value, sublevelErr: false })}>
                                                                    <option> {lang === 'ar' ? " الصف" : " sub level"} </option>
                                                                    {this.state.subLevels.map((items, index) => (
                                                                        <option value={items.id}> {items.name} </option>
                                                                    ))}

                                                                </Input>
                                                            </FormGroup>
                                                            {this.state.sublevelErr &&
                                                                <h6 className={lang === "en" ? "labelInput LeftAlign" : "labelInput RightAlign"}
                                                                    style={{ color: 'red' }}>  {lang === 'ar' ? ' يرجى اختيار الصف  ' : 'Please choose sub level'} </h6>
                                                            }

                                                        </Col>

                                                    }
                                                    {(this.state.userType && this.state.userType === 'TEACHER') &&
                                                        <Col lg="6" md="6">
                                                            <FormGroup>
                                                                <Label className={lang === "en" ? "labelInput LeftAlign" : "labelInput RightAlign"}> {lang === 'ar' ? "اختر البلد" : "Choose the country"} </Label>
                                                                <Input type="select" style={{ backgroundColor: "#eeeeee", borderRadius: '10px' }}
                                                                    onChange={(e) => {
                                                                        this.GetCities(e.target.value)
                                                                        this.setState({ country: e.target.value, countryErr: false })
                                                                    }}>
                                                                    <option> {lang === 'ar' ? " البلد" : "Country"} </option>
                                                                    {this.state.countries.map((items, index) => (
                                                                        <option value={items.id}> {items.name} </option>
                                                                    ))}

                                                                </Input>
                                                            </FormGroup>
                                                            {this.state.countryErr &&
                                                                <h6 className={lang === "en" ? "labelInput LeftAlign" : "labelInput RightAlign"}
                                                                    style={{ color: 'red' }}>  {lang === 'ar' ? ' يرجى اختيار البلد  ' : 'Please choose the country'} </h6>
                                                            }
                                                        </Col>

                                                    }

                                                    {(this.state.userType === 'TEACHER' && this.state.country) &&
                                                        <Col lg="6" md="6">
                                                            <FormGroup>
                                                                <Label className={lang === "en" ? "labelInput LeftAlign" : "labelInput RightAlign"}> {lang === 'ar' ? "اختر المحافظة" : "Choose the city"} </Label>
                                                                <Input type="select" style={{ backgroundColor: "#eeeeee", borderRadius: '10px' }}
                                                                    onChange={(e) => {
                                                                        this.GetArea(e.target.value)
                                                                        this.setState({ city: e.target.value, cityErr: false })
                                                                    }}>
                                                                    <option> {lang === 'ar' ? " المحافظة" : "City"} </option>
                                                                    {this.state.cities.map((items, index) => (
                                                                        <option value={items.id}> {items.name} </option>
                                                                    ))}

                                                                </Input>
                                                            </FormGroup>
                                                            {this.state.cityErr &&
                                                                <h6 className={lang === "en" ? "labelInput LeftAlign" : "labelInput RightAlign"}
                                                                    style={{ color: 'red' }}>  {lang === 'ar' ? ' يرجى اختيار المحافظة  ' : 'Please choose the city'} </h6>
                                                            }
                                                        </Col>
                                                    }
                                                    {(this.state.userType === 'TEACHER' && this.state.city) &&
                                                        <Col lg="6" md="6">
                                                            <FormGroup>
                                                                <Label className={lang === "en" ? "labelInput LeftAlign" : "labelInput RightAlign"}> {lang === 'ar' ? "اختر المنطقة" : "Choose the area"} </Label>
                                                                <Input type="select" style={{ backgroundColor: "#eeeeee", borderRadius: '10px' }}
                                                                    onChange={(e) => this.setState({ area: e.target.value, areaErr: false })}>
                                                                    <option> {lang === 'ar' ? " المنطقة" : "Area"} </option>
                                                                    {this.state.areas.map((items, index) => (
                                                                        <option value={items.id}> {items.name} </option>
                                                                    ))}

                                                                </Input>
                                                            </FormGroup>
                                                            {this.state.areaErr &&
                                                                <h6 className={lang === "en" ? "labelInput LeftAlign" : "labelInput RightAlign"}
                                                                    style={{ color: 'red' }}>  {lang === 'ar' ? ' يرجى اختيار المنطقة  ' : 'Please choose the area'} </h6>
                                                            }
                                                        </Col>
                                                    }

                                                    <Col md="12" className="login-submit-Btn mt-4" style={{ textAlign: 'center' }} >
                                                        <Button onClick={() => this.showTypeError()} type="submit" className="btn submitBtn" disabled={submitting}> {String.signup}  </Button>
                                                    </Col>
                                                    <Col md="12" className="signup-ques" >
                                                        <Link to="/login" className="login-click"> <h6> {String.signinQues}  </h6> </Link>
                                                    </Col>
                                                </Row>
                                            )
                                        })
                                    }

                                </Form>


                            </Col>
                        </Row>

                    </div>
                </div>
                {/*  textAlign: lang === "ar" ? "right" : "left", */}
                <Modal style={{ marginTop: "10%" }} isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} >
                    <ModalHeader style={{ display: "block", backgroundColor: "#FEC85E", color: "#fff", textAlign: "end" }} className="" toggle={this.toggle}>{String.chooseLevel}</ModalHeader>
                    <ModalBody>
                        <Form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                            <Col lg="12" md="12">
                                <FormGroup>
                                    <Label className={lang === "en" ? "labelInput LeftAlign" : "labelInput RightAlign"}> {lang === 'ar' ? "اختر المرحلة" : "Choose level"} </Label>
                                    <Input type="select" style={{ backgroundColor: "#eeeeee", borderRadius: '10px' }}
                                        onChange={(e) => {
                                            this.GetSubLevel(e.target.value)
                                            this.setState({ level: e.target.value, levelErr: false })
                                        }}>
                                        <option> {lang === 'ar' ? " المرحلة" : "Level"} </option>
                                        {this.state.Levels.map((items, index) => (
                                            <option value={items.id}> {items.name} </option>
                                        ))}

                                    </Input>
                                </FormGroup>
                                {this.state.levelErr &&
                                    <h6 className={lang === "en" ? "labelInput LeftAlign" : "labelInput RightAlign"}
                                        style={{ color: 'red' }}>  {lang === 'ar' ? ' يرجى اختيار المرحلة  ' : 'Please choose level'} </h6>
                                }

                            </Col>
                            {this.state.level &&
                                <Col lg="12" md="12">
                                    <FormGroup>
                                        <Label className={lang === "en" ? "labelInput LeftAlign" : "labelInput RightAlign"}> {lang === 'ar' ? "اختر الصف" : "Choose sub level"} </Label>
                                        <Input type="select" style={{ backgroundColor: "#eeeeee", borderRadius: '10px' }}
                                            onChange={(e) => this.setState({ sublevel: e.target.value, sublevelErr: false })}>
                                            <option> {lang === 'ar' ? " الصف" : " sub level"} </option>
                                            {this.state.subLevels.map((items, index) => (
                                                <option value={items.id}> {items.name} </option>
                                            ))}

                                        </Input>
                                    </FormGroup>
                                    {this.state.sublevelErr &&
                                        <h6 className={lang === "en" ? "labelInput LeftAlign" : "labelInput RightAlign"}
                                            style={{ color: 'red' }}>  {lang === 'ar' ? ' يرجى اختيار الصف  ' : 'Please choose sub level'} </h6>
                                    }

                                </Col>

                            }
                        </Form>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="footerVisitor" onClick={() => { this.viewAsVisitor() }}>{String.Continue}</Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        sucessRegister: state.login.sucessRegister
    }
}
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        RegisterRequest,
        visit
    }
    , dispatch
)
export default reduxForm({
    form: 'fieldLevelValidation',
    validate
})(connect(mapStateToProps, mapDispatchToProps)(SignUp));